// constants
import { PROVIDERS_LISTS, PROVIDERS } from '@/utils/constants'

import localDeposit from '@/mixins/localDeposit.js'
export default {
  mixins: [localDeposit],
  data () {
    return {
      hub2Config: {}
    }
  },
  computed: {
    supportedBanksProvider () {
      return Object.keys(this.$store.state.terminal.supportedBanks)[0]
    },
    isHub2Provider () {
      return (
        this.supportedBanksProvider === PROVIDERS.HUB2 &&
        this.isHub2SupportedCurrency
      )
    },
    hub2ProviderDetails () {
      return PROVIDERS_LISTS.find(
        (provider) => provider.value === PROVIDERS.HUB2
      )
    },

    isHub2SupportedCurrency () {
      return (
        this.secondaryCurrencyIsXAF ||
        this.secondaryCurrencyIsXOF ||
        this.hub2Config.currency === this.$CURRENCY.XAF ||
        this.hub2Config.currency === this.$CURRENCY.XOF
      )
    }
  },
  methods: {
    async handleHub2ProviderPayout (config, callback = '') {
      // set payout method
      this.hub2Config = config
      if (this.isHub2SupportedCurrency) {
        await this.getSupportedBanks()
        if (callback) callback()
      }
    },
    async getSupportedBanks () {
      const payload = {
        currency: this.hub2Config.currency,
        payoutType:
          this.hub2Config.payoutMethod === 'mobile_money' ||
          this.hub2Config.payoutMethod === 'mno'
            ? 'mno'
            : ''
      }
      this.isLoadingHub2ProviderBanks = true
      await this.$store
        .dispatch('terminal/getSupportedBanks', payload)
        .then(() => {
          this.isLoadingHub2ProviderBanks = false
        })
        .finally(() => {
          this.isLoadingHub2ProviderBanks = false
        })
    }
  }
}
